import { call, takeEvery } from 'redux-saga/effects';
import {
  DoRequestResponse,
  GlobalActions,
  GlobalPut,
  HTTP_METHOD,
} from '@ps20-frontend/shop-integration-redux';
import { ValidationRegexResponseModel } from '@ps20/bff-models';
import { Regexps, App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { PS20Logger } from '@ps20-frontend/logging';

export enum REGEXPS_REQUESTED_EVENTS {
  REGEXPS_REQUESTED_SUCCESSFUL = 'REGEXPS_REQUESTED_SUCCESSFUL',
  REGEXPS_REQUESTED_FAILED = 'REGEXPS_REQUESTED_FAILED',
}

export function* watchRegexpsRequestedEvent() {
  yield takeEvery(GlobalActions.AUTHENTICATION_SUCCESSFUL, safeSaga(getRegexps, App.SHOP));
  yield takeEvery(GlobalActions.SAVED_STATES_LOADED, safeSaga(getRegexps, App.SHOP));
  yield takeEvery(
    REGEXPS_REQUESTED_EVENTS.REGEXPS_REQUESTED_SUCCESSFUL,
    safeSaga(successCallback, App.SHOP),
  );
  yield takeEvery(
    REGEXPS_REQUESTED_EVENTS.REGEXPS_REQUESTED_FAILED,
    safeSaga(errorCallback, App.SHOP),
  );
}

export function* getRegexps() {
  const globalPut = GlobalPut.getInstance();
  yield call(
    [globalPut, globalPut.put],
    new GlobalActions().doRequest({
      appId: App.SHOP,
      url: 'privatschutz/api/regexes',
      method: HTTP_METHOD.GET,
      successEvent: REGEXPS_REQUESTED_EVENTS.REGEXPS_REQUESTED_SUCCESSFUL,
      errorEvent: REGEXPS_REQUESTED_EVENTS.REGEXPS_REQUESTED_FAILED,
    }),
  );
}

export function* successCallback(successAction: DoRequestResponse<ValidationRegexResponseModel>) {
  const globalPut = GlobalPut.getInstance();

  const regexps: Regexps = Object.keys(successAction.payload.regexes).reduce((tempRegexps: Regexps, key) => {
    tempRegexps[key] = successAction.payload.regexes[key];
    return tempRegexps;
  }, {});
  yield call(globalPut.put, new GlobalActions().regexpsReceived(regexps));
}

export function errorCallback(errorAction: DoRequestResponse<ValidationRegexResponseModel>) {
  PS20Logger.error(App.SHOP, 'Loading regexps from bff failed.', errorAction.payload.toString());
}
